module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ii",
      "title": "ii"
    }
  }, [_vm._v("Most Charisma Media products are available at special quantity discounts for bulk purchase for sales promotions, premiums, fundraising, and educational needs. For details, call us at (407) 333-0600 or visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.charismamedia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.charismamedia.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYERS")]), _vm._v(" by John Ramirez")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Published by Charisma House, an imprint of Charisma Media")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("600 Rinehart Road, Lake Mary, Florida 32746")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("This book or parts thereof may not be reproduced in any form, stored in a retrieval system, or transmitted in any form by any means—electronic, mechanical, photocopy, recording, or otherwise—without prior written permission of the publisher, except as provided by United States of America copyright law.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Unless otherwise noted, all Scripture quotations are taken from the Amplified® Bible ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMP")]), _vm._v("), Copyright © 2015 by The Lockman Foundation. Used by permission. "), _c('a', {
    attrs: {
      "href": "http://www.Lockman.org",
      "target": "_blank"
    }
  }, [_vm._v("www.Lockman.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPC")]), _vm._v(" are from the Amplified® Bible ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPC")]), _vm._v("), Copyright © 1954, 1958, 1962, 1964, 1965, 1987 by The Lockman Foundation. Used by permission. "), _c('a', {
    attrs: {
      "href": "http://www.Lockman.org",
      "target": "_blank"
    }
  }, [_vm._v("www.Lockman.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")]), _vm._v(" are from the King James Version of the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")]), _vm._v(" are taken from the Holy Bible, New International Version®, NIV®. Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.® Used by permission of Zondervan. All rights reserved worldwide. "), _c('a', {
    attrs: {
      "href": "http://www.zondervan.com",
      "target": "_blank"
    }
  }, [_vm._v("www.zondervan.com")]), _vm._v(". The “NIV” and “New International Version” are trademarks registered in the United States Patent and Trademark Office by Biblica, Inc.®")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v(" are taken from the New King James Version®. Copyright © 1982 by Thomas Nelson. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLT")]), _vm._v(" are from the Holy Bible, New Living Translation, copyright © 1996, 2004, 2007. Used by permission of Tyndale House Publishers, Inc., Wheaton, IL 60189. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iii",
      "title": "iii"
    }
  }, [_vm._v("Text in braces {} in the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMP")]), _vm._v(" OR "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPC")]), _vm._v(" was added by the author.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Copyright © 2023 by John Ramirez")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Visit the author’s website at "), _c('a', {
    attrs: {
      "href": "https://johnramirez.org",
      "target": "_blank"
    }
  }, [_vm._v("https://johnramirez.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Cataloging-in-Publication Data is on file with the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("International Standard Book Number: 978-1-63641-155-2")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("E-book ISBN: 978-1-63641-156-9")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("While the author has made every effort to provide accurate internet addresses at the time of publication, neither the publisher nor the author assumes any responsibility for errors or for changes that occur after publication. Further, the publisher does not have any control over and does not assume any responsibility for author or third-party websites or their content.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0